import Link from 'next/link';
import React from 'react';
import { PictureWithFallback } from '../../../sections/PictureWithFallback';
import { CloseIcon } from '../../../svg/CloseIcon';
import { gql } from '@urql/core';
import { PlayerSelectedConversationFragment } from '../../../../generated/spin-graphql';
import { PlayerChatBubbles } from './PlayerChatBubbles';

type Props = {
    onBackClicked: () => void;
    selectedConversation: PlayerSelectedConversationFragment[];
};

gql`
    fragment PlayerSelectedConversation on espin_message {
        ...PlayerChatBubbles
        college {
            logo {
                ...SpinContentImageDisplay
            }
            name
            slug
        }
    }
`;

export const PlayerSelectedConversation: React.FC<Props> = ({ onBackClicked, selectedConversation }) => {
    const profileImage = selectedConversation[0].college?.logo;
    const nameLabel = selectedConversation[0].college?.name ?? 'Unverified College';
    const slug = selectedConversation[0].college?.slug ?? '';
    return (
        <>
            <div className="header-container">
                <div className="image-wrapper">
                    <PictureWithFallback
                        width={40}
                        height={40}
                        icon={profileImage}
                        alt={`${nameLabel}'s profile picture`}
                    />
                </div>
                <Link href={`/colleges/${slug}`}>
                    <a className="username">{nameLabel}</a>
                </Link>
                <button onClick={onBackClicked} className="button circle-button back-button">
                    <CloseIcon />
                </button>
            </div>
            <div className="content">
                <PlayerChatBubbles conversation={selectedConversation} />
            </div>
        </>
    );
};
